/**
 * Get country code for a country name.
 *
 * Uses values from localeSelector dropdown.
 */

  let countries;

  /**
   * Lookup country code for a country name
   * @param  {String} countryName For example 'France'
   * @param {String=} defaultValue If result is not found this value is returned (if not supplied countryName is returned)
   * @return {String}             2 letter character code, or inputted countryName if not found
   */
  export default function getCountryCode(countryName, defaultValue) {
    if (!countries) {
      const select = document.getElementsByClassName('localeSelector-countrySelect').item(0);
      if (select) {
        countries = {};
        const len = select.options.length;
        for (let i = 0; i < len; i++) {
          const option = select.options[i];
          if (option.value.length === 2) {
            countries[option.value] = option.text;
          }
        }
      }
    }

    if (countries) {
      countryName = countryName.toLowerCase();
      for (const countryCode in countries) {
        if (countries[countryCode].toLowerCase() === countryName) {
          return countryCode;
        }
      }
    }
    return defaultValue !== undefined ? defaultValue : countryName;
  };

